import { render, staticRenderFns } from "./CS.vue?vue&type=template&id=231c32c1&scoped=true&"
import script from "./CS.vue?vue&type=script&lang=ts&"
export * from "./CS.vue?vue&type=script&lang=ts&"
import style0 from "./CS.vue?vue&type=style&index=0&id=231c32c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c32c1",
  null
  
)

export default component.exports